"use strict";

import $ from 'jquery';

import Lenis from 'lenis';

import LazyLoad from 'vanilla-lazyload';

// SimpleShare
import SimpleShare from './plugins/simpleshare/index.js';

// AOS
import AOS from 'aos';
import 'aos/dist/aos.css';

import { layer } from './plugins/layer/index.js';

// vanilla-cookieconsent
// import cookieConsent from './plugins/cookie-consent';

import '@splidejs/splide/css';
import Splide from '@splidejs/splide';
import { Grid } from '@splidejs/splide-extension-grid';

// import imagesLoaded from 'imagesloaded';
// import jQueryBridget from 'jquery-bridget';
// import Masonry from 'masonry-layout';
// jQueryBridget('masonry', Masonry, $);

import validate from 'jquery-validation';
import axios from 'axios';

// gsap
import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

import * as CookieConsent from 'vanilla-cookieconsent';
import 'vanilla-cookieconsent/dist/cookieconsent.css';

// import Cropper from 'cropperjs';
// import 'cropperjs/dist/cropper.css';

import 'select2/dist/css/select2.min.css';
import select2 from 'select2';


import './iconfont/iconfont.js';
import { type } from 'os';

import Language from './language.js';
const lang = new Language();


jQuery.validator.addMethod("isMobile", function (value, element) {
	var length = value.length;
	var mobile = /^(1[0-9][0-9]{9})|(18[0-9]{9})|(14[0-9]{9})|(17[0-9]{9})|(15[0-9]{9})$/;
	return this.optional(element) || (length == 11 && mobile.test(value));
}, lang.phoneErr);
jQuery.validator.addMethod("valueNotEquals", function (value, element, arg) {
	return arg !== value;
}, lang.selectAnItem);
jQuery.extend(jQuery.validator.messages, {
	required: lang.required,
	email: lang.emailErr
});


(function ($, window, document, undefined) {

	// our plugin constructor
	var OnePageNav = function (elem, options) {
		this.elem = elem;
		this.$elem = $(elem);
		this.options = options;
		this.metadata = this.$elem.data('plugin-options');
		this.$win = $(window);
		this.sections = {};
		this.didScroll = false;
		this.$doc = $(document);
		this.docHeight = this.$doc.height();
	};

	// the plugin prototype
	OnePageNav.prototype = {
		defaults: {
			navItems: 'a',
			currentClass: 'current',
			changeHash: false,
			easing: 'swing',
			filter: '',
			scrollSpeed: 750,
			scrollThreshold: 0.5,
			begin: false,
			end: false,
			scrollChange: false
		},

		init: function () {
			// Introduce defaults that can be extended either
			// globally or using an object literal.
			this.config = $.extend({}, this.defaults, this.options, this.metadata);

			this.$nav = this.$elem.find(this.config.navItems);

			//Filter any links out of the nav
			if (this.config.filter !== '') {
				this.$nav = this.$nav.filter(this.config.filter);
			}

			//Handle clicks on the nav
			this.$nav.on('click.onePageNav', $.proxy(this.handleClick, this));

			//Get the section positions
			this.getPositions();

			//Handle scroll changes
			this.bindInterval();

			//Update the positions on resize too
			this.$win.on('resize.onePageNav', $.proxy(this.getPositions, this));

			return this;
		},

		adjustNav: function (self, $parent) {
			self.$elem.find('.' + self.config.currentClass).removeClass(self.config.currentClass);
			$parent.addClass(self.config.currentClass);
		},

		bindInterval: function () {
			var self = this;
			var docHeight;

			self.$win.on('scroll.onePageNav', function () {
				self.didScroll = true;
			});

			self.t = setInterval(function () {
				docHeight = self.$doc.height();

				//If it was scrolled
				if (self.didScroll) {
					self.didScroll = false;
					self.scrollChange();
				}

				//If the document height changes
				if (docHeight !== self.docHeight) {
					self.docHeight = docHeight;
					self.getPositions();
				}
			}, 250);
		},

		getHash: function ($link) {
			return $link.attr('href').split('#')[1];
		},

		getPositions: function () {
			var self = this;
			var linkHref;
			var topPos;
			var $target;

			self.$nav.each(function () {
				linkHref = self.getHash($(this));
				$target = $('#' + linkHref);

				if ($target.length) {
					topPos = $target.offset().top;
					self.sections[linkHref] = Math.round(topPos);
				}
			});
		},

		getSection: function (windowPos) {
			var returnValue = null;
			var windowHeight = Math.round(this.$win.height() * this.config.scrollThreshold);

			for (var section in this.sections) {
				if ((this.sections[section] - windowHeight) < windowPos) {
					returnValue = section;
				}
			}

			return returnValue;
		},

		handleClick: function (e) {
			var self = this;
			var $link = $(e.currentTarget);
			var $parent = $link.parent();
			var newLoc = '#' + self.getHash($link);

			if (!$parent.hasClass(self.config.currentClass)) {
				//Start callback
				if (self.config.begin) {
					self.config.begin();
				}

				//Change the highlighted nav item
				self.adjustNav(self, $parent);

				//Removing the auto-adjust on scroll
				self.unbindInterval();

				//Scroll to the correct position
				self.scrollTo(newLoc, function () {
					//Do we need to change the hash?
					if (self.config.changeHash) {
						window.location.hash = newLoc;
					}

					//Add the auto-adjust on scroll back in
					self.bindInterval();

					//End callback
					if (self.config.end) {
						self.config.end();
					}
				});
			}

			e.preventDefault();
		},

		scrollChange: function () {
			var windowTop = this.$win.scrollTop();
			var position = this.getSection(windowTop);
			var $parent;

			//If the position is set
			if (position !== null) {
				$parent = this.$elem.find('a[href$="#' + position + '"]').parent();

				//If it's not already the current section
				if (!$parent.hasClass(this.config.currentClass)) {
					//Change the highlighted nav item
					this.adjustNav(this, $parent);

					//If there is a scrollChange callback
					if (this.config.scrollChange) {
						this.config.scrollChange($parent);
					}
				}
			}
		},

		scrollTo: function (target, callback) {
			var offset = $(target).offset().top;

			$('html, body').animate({
				scrollTop: offset
			}, this.config.scrollSpeed, this.config.easing, callback);
		},

		unbindInterval: function () {
			clearInterval(this.t);
			this.$win.unbind('scroll.onePageNav');
		}
	};

	OnePageNav.defaults = OnePageNav.prototype.defaults;

	$.fn.onePageNav = function (options) {
		return this.each(function () {
			new OnePageNav(this, options).init();
		});
	};

})(jQuery, window, document);


// Lenis

// Header
(() => {
	const $body = $('body');
	window.lenis = new Lenis()
	window.lenis.on('scroll', ({ scroll, limit, velocity, direction, progress }) => {
		scroll > 60 ? $body.addClass('fixed-menu') : $body.removeClass('fixed-menu')
		direction > 0 ? $body.addClass('drop-menu') : $body.removeClass('drop-menu')

		// ScrollTrigger.update();

		// AOS.refresh();

	});
	function raf(time) {
		window.lenis.raf(time)
		requestAnimationFrame(raf)
	}

	requestAnimationFrame(raf)

	$(window).trigger('scroll');

	// gsap.ticker.add((time)=>{
	// 	window.lenis.raf(time * 1000)
	// });

	// gsap.ticker.lagSmoothing(0);

	$('.js-btn-menu').on('click', function () {
		$('body').toggleClass('menu-open');
	});

	$('.js-hm-dropdown').on('click', function () {
		const hmItem = $(this).parents('.hm-item');
		const hmSub = hmItem.find('.hm-sub');
		if (hmItem.hasClass('active')) {
			hmItem.removeClass('active');
			hmSub.slideUp('300');
		} else {
			hmItem.addClass('active');
			hmSub.slideDown('300');
		}
	});

})();

// Index
// if (document.querySelector('.page-index')) {
// 	import('./page/index').then((res)=>{
// 		res.default();
// 	})
// }

import pageIndex from './page/index.js';
pageIndex();


// Our Service
(() => {

	$('.js-oservp1-tab span').on('click', function () {
		const index = $(this).index();
		$(this).addClass('current').siblings().removeClass('current');
		$('.oservp1-con').eq(index).addClass('active').siblings().removeClass('active');
	});

	if (document.querySelector('.js-splide-ptime')) {

		var ptimes = document.getElementsByClassName('js-splide-ptime');

		for (var i = 0; i < ptimes.length; i++) {
			new Splide(ptimes[i], {
				breakpoints: {
					1920: {
						gap: '1.5625vw'
					},
					1100: {
						type: 'loop',
						focus: 'center',
						autoWidth: true,
						gap: 15
					}
				}
			}).mount();
		}
	}

	if (document.querySelector('.js-splide-servicen')) {
		const splideSern = new Splide('.js-splide-servicen', {
			gap: '1.5625vw',
			perPage: 3,
			perMove: 1,
			breakpoints: {
				768: {
					autoWidth: true,
					gap: '15px',
					pagination: true,
					focus: "center",
					type: "loop",
					autoplay: true
				}
			}
		}).mount();
	}


	$('.oservp3-item__ico').on('click', function () {
		const i = $(this).parents('.oservp3-item').index();

		$('.oservp3-item').each(function (index, item) {
			const body = $(item).find('.oservp3-item__body');
			if (i === index) {
				if ($(item).hasClass('active')) {
					$(item).removeClass('active');
					body.slideUp(300);
				} else {
					$(item).addClass('active');
					body.slideDown(300);
				}
			} else {
				if ($(item).hasClass('active')) {
					$(item).removeClass('active');
					body.slideUp(300);
				}
			}
		});
	});

})();

// Infrastructure
(() => {

	if (document.querySelector('.js-splide-ifra')) {

		var ifras = document.getElementsByClassName('js-splide-ifra');

		for (var i = 0; i < ifras.length; i++) {
			new Splide(ifras[i], {
				breakpoints: {
					1100: {
						type: 'loop',
						focus: 'center',
						autoWidth: true,
						gap: 15
					}
				}
			}).mount();
		}
	}

	$('.ifra-item__more').on('click', function () {
		const item = $(this).parents('.ifra-item');
		item.toggleClass('active');
	});

})();

// About
(() => {
	if (document.querySelector('.js-splide-aboutc')) {
		const splideAboutc = new Splide('.js-splide-aboutc', {
			breakpoints: {
				1100: {
					type: 'loop',
					focus: 'center',
					autoWidth: true,
					gap: 15
				}
			}
		}).mount();
	}

	if (document.querySelector('.js-splide-aht')) {

		const splideAht = new Splide('.js-splide-aht', {
			breakpoints: {
				1100: {
					perPage: 4
				}
			}
		}).mount();

		$('.js-splide-aht-prev').on('click', function () {
			splideAht.go('<');
		});
		$('.js-splide-aht-next').on('click', function () {
			splideAht.go('>');
		});

		const splideAhd = new Splide('.js-splide-ahd', {
		}).mount();

		splideAht.sync(splideAhd);

		$('.js-splide-ahd-prev').on('click', function () {
			splideAhd.go('<');
		});
		$('.js-splide-ahd-next').on('click', function () {
			splideAhd.go('>');
		});
		function setHeight() {
			const h = $('.js-splide-ahd').find('.splide__slide.is-active').find('.ahd-item').outerHeight();
			$('.js-splide-ahd').css({
				height: h
			});
		}
		setHeight();

		splideAhd.on('moved', function (newIndex, prevIndex, destIndex) {
			setHeight();
		});

	}

	if (document.querySelector('.js-splide-aboutp')) {
		let splideAboutp = null;
		if (window.innerWidth > 1100) {
			splideAboutp = new Splide('.js-splide-aboutp', {
				perPage: 2,
				gap: 30
			}).mount();
		} else {
			splideAboutp = new Splide('.js-splide-aboutp', {
				type: 'fade'
			}).mount();
			$('.js-aboutp-prev').on('click', function () {
				splideAboutp.go('<');
			});
			$('.js-aboutp-next').on('click', function () {
				splideAboutp.go('>');
			});

		}
	}

	if (document.querySelector('.animate-num')) {
		const nums = document.querySelectorAll('.animate-num');

		for (let i = 0; i < nums.length; i++) {
			nums[i].style.width = nums[i].clientWidth + 'px';
		}

		var isAniNum = false;

		const timing = $('.js-animnum-box').data('timing');

		var reg = /^[,]+$/;

		$(window).on('scroll', function () {
			if ($(window).scrollTop() > $('.js-animnum-box').offset().top - $(window).height() + 100 && $(window).scrollTop() < $('.js-animnum-box').offset().top) {
				if (!isAniNum) {
					isAniNum = true;
					$('.animate-num').each(function () {
						const i = $(this).text().indexOf(',');
						$(this).prop('Counter', 0).animate({
							Counter: $(this).text().replace(',', '')
						}, {
							duration: timing,
							easing: 'swing',
							step: function (now) {
								if (i > 0) {
									$(this).text(Math.ceil(now) < 10 ? '0' + Math.ceil(now) : Math.ceil(now).toLocaleString());
								} else {
									$(this).text(Math.ceil(now) < 10 ? '0' + Math.ceil(now) : Math.ceil(now));
								}
							}
						});
					});
				}
			}
		}).trigger('scroll');
	}

})();

// Comm
(() => {

	if (document.querySelector('.js-aline-box')) {
		const pathLen = Math.ceil($('.js-aline-path')[0].getTotalLength());

		const tl = new gsap.timeline();
		tl.set('.js-aline-path', { strokeDasharray: pathLen, strokeDashoffset: pathLen, opacity: 1 });
		tl.set('.js-aline-img', { y: 20, opacity: 0 });
		tl.set('.js-aline-link', { y: 20, opacity: 0 });
		tl.to('.js-aline-path', { strokeDashoffset: 0, duration: 1 });
		tl.to('.js-aline-img', { y: 0, opacity: 1, duration: 1 }, "-=.3");
		tl.to('.js-aline-link', { y: 0, opacity: 1, duration: 1 }, "-=.5");

		tl.pause();

		let isPause = true;
		ScrollTrigger.create({
			trigger: '.js-aline-box',
			start: `top 75%`,
			end: 'bottom bottom',
			markers: false,
			onEnter: ({ progress, direction, isActive }) => {
				if (isPause) {
					isPause = false;
					tl.play();
				}

			}
		});
	}

	if (document.querySelector('.js-splide-icard')) {
		const splideIcard = new Splide('.js-splide-icard', {

		}).mount();

		$('.js-icard-prev').on('click', function () {
			splideIcard.go('<');
		});
		$('.js-icard-next').on('click', function () {
			splideIcard.go('>');
		});
	}

})();

// Contact Us
(() => {
	if (document.querySelector('.company-item__header')) {
		$('.company-item__header').on('click', function () {
			const i = $(this).parents('.company-item').index();

			$('.company-item').each(function (index, item) {
				const body = $(item).find('.company-item__body');
				const imgbox = $(item).find('.company-item__img');
				if (i === index) {
					if ($(item).hasClass('active')) {
						$(item).removeClass('active');
						body.stop().slideUp(300);
						imgbox.stop().slideUp(300);
					} else {
						$(item).addClass('active');
						body.stop().slideDown(300);
						imgbox.stop().slideDown(300);
					}
				} else {
					if ($(item).hasClass('active')) {
						$(item).removeClass('active');
						const time = window.innerWidth > 1100 ? 300 : 0;
						setTimeout(() => {
							body.stop().slideUp(300);
							imgbox.stop().slideUp(300);
						}, time);

					}
				}
			});
		});
	}


	$('.js-list-job-more').on('click', function () {
		const box = $(this).parents('.list-job-box');
		box.toggleClass('show');
	})

})();

// Footer
(() => {
	if ($('.js-select2').length) {
		$('.js-select2').select2({
			placeholder: '',
			minimumResultsForSearch: Infinity,
			dropdownParent: $('#select2Dropdown')
		});
	}

	if ($('#contactForm').length) {
		let isSubmit = true;
		const form = $('#contactForm');
		const btnSubmit = form.find('.fcf-submit');
		form.validate({
			submitHandler: function (form) {
				if (isSubmit) {
					isSubmit = false;
					const postURL = $(form).attr('action');
					const postData = $(form).serialize();

					axios.post(postURL, postData)
						.then(function (res) {
							if (res.data.code == '200') {
								layer.msg(res.data.msg);
								$('#contactForm')[0].reset();
							} else {
								layer.msg(res.data.msg);
							}
							isSubmit = true;
						})
						.catch(function (err) {
							layer.msg(err.data.msg);
							isSubmit = true;
						});
				}
			},
			rules: {
				name: {
					required: true
				},
				title: {
					required: true
				},
				company: {
					required: true
				},
				phone: {
					required: true
				},
				email: {
					required: true,
					email: true
				}
			}
		})
		btnSubmit.on('click', function () {
			form.submit();
		});
	}


	if (document.querySelector('.fixed-zx')) {
		const btn = document.querySelector('.fixed-zx')

		// console.log(btn.offsetTop, window.innerHeight - 120);

		if (document.querySelector('.page-banner')) {
			gsap.set('.fixed-zx', { y: 0 });
			let tl = gsap.timeline({
				scrollTrigger: {
					trigger: '.page-banner',
					start: 'center top',
					end: 'bottom top',
					pin: false,
					scrub: true
				}
			});
			tl.to('.fixed-zx', { y: window.innerHeight - 120 - btn.offsetTop - btn.offsetHeight });
		}


	}

	const fslinks = document.querySelectorAll('.js-fs-link-qrcode');
	fslinks.forEach(fslink => {
		const imgurl = fslink.getAttribute('data-img');
		const title1 = fslink.getAttribute('data-title1');
		const title2 = fslink.getAttribute('data-title2');
		fslink.addEventListener('click', () => {
			showQRcode(imgurl, title1, title2)
		});
	});

	function showQRcode(img, title1, title2) {
		const layerQRcode = document.createElement('div');
		layerQRcode.innerHTML = `<div class="layer-wechat-box fixed top-0 right-0 bottom-0 left-0">
									<div class="absolute top-0 right-0 bottom-0 left-0 flex justify-center items-center bg-black50">
										<div class="bg-white relative layer-wechat p-40 text-center">
											<span class="layer-wechat__close absolute top-0 right-0 text-20 cursor-pointer">
												<svg><use xlink:href="#icon-close"></use></svg>
											</span>
											<h3 class="text-20 lg:text-16 font-500 text-center">${title1}</h3>
											<img class="block layer-wechat__img mx-auto mt-20 mb-20" src="${img}" alt="">
											<p class="text-16 lg:text-14 font-500">${title2}</p>
										</div>
									</div>
								</div>`;
		const btnClose = layerQRcode.querySelector('.layer-wechat__close');
		btnClose.addEventListener('click', () => {
			layerQRcode.remove();
		});
		document.body.appendChild(layerQRcode);
	}

})();

// INIT
(() => {

	$('.js-show-more').on('click', function () {
		const box = $(this).parents('.show-more-box');
		box.toggleClass('show');
	});


	// Lazyload data-src data-bg data-poster
	var myLazyLoad = new LazyLoad({
		threshold: 200
	});

	// cookieConsent();

	// Social Share
	const share = new SimpleShare({
		url: '',
		title: '',
		content: '',
		pic: ''
	});
	$('[data-share]').on('click', function () {
		const type = $(this).attr('data-share');
		share.goShare(type);
	});

	AOS.init({
		offset: 50,
		duration: 800
	});

	if (document.querySelector('.js-page-nav')) {
		$('.js-page-nav').onePageNav();
	}

})();

// CookieConsent
(() => {
	/**
	 * All config. options available here:
	 * https://cookieconsent.orestbida.com/reference/configuration-reference.html
	*/
	document.documentElement.classList.add('cc--greenmode');
	CookieConsent.run({

		categories: {
			necessary: {
				enabled: true,  // this category is enabled by default
				readOnly: true  // this category cannot be disabled
			},
			required: {
				enabled: true,  // this category is enabled by default
				readOnly: false  // this category cannot be disabled
			},
			analytics: {}
		},

		guiOptions: {
			consentModal: {
				layout: 'bar inline',
				position: 'bottom',
				flipButtons: false,
				equalWeightButtons: true
			},
			preferencesModal: {
				layout: 'box',
				// position: 'left right',
				flipButtons: false,
				equalWeightButtons: true
			}
		},

		language: {
			default: 'en',

			translations: {
				en: {

					consentModal: {
						title: '',
						description: 'We place cookies in order to make sure our website works properly and to improve your browsing experience, to streamline and personalize our marketing content and to show you personalized advertisements (including on third party websites). We sometimes share cookie data with our partners for these purposes. Our cookies remember your settings and the data you fill out on forms on our website and analyse traffic to our website. Our cookies also register how you found us and collect information about your browsing habits. You can read more about our use of in our <a href="/cookie-policy" class="cc__link underline">Cookies Notice</a>',
						acceptAllBtn: 'Accept all',
						acceptNecessaryBtn: 'Reject all',
						showPreferencesBtn: 'Customize'
					},
					preferencesModal: {
						title: 'Manage cookie preferences',
						acceptAllBtn: 'Save settings',
						acceptNecessaryBtn: 'Reject all',
						savePreferencesBtn: 'Accept current selection',
						closeIconLabel: 'Close modal',
						sections: [
							// {
							// 	title: 'Somebody said ... cookies?',
							// 	description: 'I want one!'
							// },
							{
								title: 'Technically required',
								description: 'Required web technologies and cookies make our website technically accessible to and usable for you. This applies to fundamental base functionalities such as navigation on the website, correct display in your internet browser or requesting your consent. Without these web technologies and cookies our website does not work.',

								//this field will generate a toggle linked to the 'required' category
								linkedCategory: 'required'
							},
							{
								title: 'Analysis and statistics',
								description: 'We want to constantly improve the user-friendliness and performance of our websites. For this reason we use analysis technologies (including cookies) which pseudonymously measure and evaluate which functions and content of our websites are used, how and how often. On this basis we can improve our websites for users.',
								linkedCategory: 'analytics'
							}
							// ,
							// {
							// 	title: 'More information',
							// 	description: 'For any queries in relation to my policy on cookies and your choices, please <a href="#contact-page">contact us</a>'
							// }
						]
					}
				},
				zh_HK: {

					consentModal: {
						title: 'Cookie政策',
						description: '雲途物流（以下簡稱「我們」）希望您可以順暢、便捷地造訪我們的網站，因此，當您使用我們的網站時，我們會使用cookies來改善您的體驗。 Cookies是當您造訪我們的網站時，自動放置在您的電腦、平板電腦、手機或其他裝置（「裝置」）上的小型文字檔案。 Cookies可能包含傳統的HTML-Cookies、pixel標籤、beacons或腳本。這些cookies會包含有關您的裝置或網路使用的基本資訊。當您重新造訪我們的網站時，您的瀏覽器會將這些cookies發送回我們的網站，以便我們能夠識別您的電腦或行動設備，並個人化改善您的瀏覽體驗。我們使用哪些類型的 <a class="cc__link underline" href="/cookie-policy">Cookies</a>?',
						acceptAllBtn: '同意',
						acceptNecessaryBtn: '拒絕',
						showPreferencesBtn: '自定義'
					},
					preferencesModal: {
						title: '管理 cookie 首選項',
						acceptAllBtn: '儲存設定',
						acceptNecessaryBtn: '全部拒絕',
						savePreferencesBtn: '接受目前選擇',
						closeIconLabel: '關閉',
						sections: [
							// {
							// 	title: 'Somebody said ... cookies?',
							// 	description: 'I want one!'
							// },
							{
								title: '技術要求',
								description: '所需的網路技術和 cookie 使我們的網站在技術上可供您存取和使用。這適用於基本的基本功能，例如網站導航、網路瀏覽器中的正確顯示或要求您的同意。如果沒有這些網路技術和 cookie，我們的網站將無法運作。',

								//this field will generate a toggle linked to the 'required' category
								linkedCategory: 'required'
							},
							{
								title: '分析統計',
								description: '我們希望不斷提高網站的使用者友善性和效能。因此，我們使用分析技術（包括 cookie），以匿名方式衡量和評估我們網站的哪些功能和內容的使用方式、使用方式和頻率。在此基礎上我們可以為使用者改進我們的網站。',
								linkedCategory: 'analytics'
							}
							// ,
							// {
							// 	title: 'More information',
							// 	description: 'For any queries in relation to my policy on cookies and your choices, please <a href="#contact-page">contact us</a>'
							// }
						]
					}
				}
			}
		}
	});
});
